export const EXTERNAL_DOMAINS = {
  CANVAS: 'https://pgaofamerica.instructure.com',
  EVENTS: 'https://events.pga.org',
  LEGACY_APPS: 'https://apps.pga.org/professionals/apps/education',
  GOOGLE_MAPS: 'https://www.google.com/maps'
}

export const CANVAS_URLS = {
  // Base portal access
  HOME: EXTERNAL_DOMAINS.CANVAS,
  
  // Course listings
  COURSES: `${EXTERNAL_DOMAINS.CANVAS}/courses`,
  
  // Specific course pages
  LEVEL_1_COURSE: `${EXTERNAL_DOMAINS.CANVAS}/courses/712`,
  LEVEL_1_PORTFOLIO: `${EXTERNAL_DOMAINS.CANVAS}/courses/463/modules`,
  VIRTUAL_SEMINAR_CONFERENCE: `${EXTERNAL_DOMAINS.CANVAS}/courses/462/conferences`,
}

export const EVENTS_URLS = {
  // Base events page
  HOME: EXTERNAL_DOMAINS.EVENTS,
  
  // My Events dashboard
  MY_EVENTS: `${EXTERNAL_DOMAINS.EVENTS}/my-events`,
  
  // Search configurations (use with interpolate for timestamps)
  PAT_SEARCH: `${EXTERNAL_DOMAINS.EVENTS}/search?numericFilters%5B0%5D=start_datetime_unix%3E%3D{{unixTimestamp}}&hitsPerPage=10&page=1&refinementList%5Bevent_categories%5D%5B0%5D=Playing%20Ability%20Test&configure%5BaroundRadius%5D=40225&configure%5BaroundLatLngViaIP%5D=true`,
  
  EDUCATION_SEARCH: `${EXTERNAL_DOMAINS.EVENTS}/search?numericFilters%5B0%5D=start_datetime_unix%3E%3D{{unixTimestamp}}&hitsPerPage=10&page=1&refinementList%5Bevent_categories%5D%5B0%5D=Education`,
  
  VIRTUAL_SEMINAR_L1_SEARCH: `${EXTERNAL_DOMAINS.EVENTS}/search?query=virtual%20seminar%20level%201`,
}

export const LEGACY_APP_URLS = {
  // Level registrations (use with interpolate for {{curriculumCode}} and {{pgaId}})
  // curriculumCode examples: 'pgapgm30' for v3.0, 'pgapgm31' for v3.1
  LEVEL_2_REGISTRATION: `${EXTERNAL_DOMAINS.LEGACY_APPS}/{{curriculumCode}}/level2reg.cfm?entity_id={{pgaId}}`,
  LEVEL_3_REGISTRATION: `${EXTERNAL_DOMAINS.LEGACY_APPS}/{{curriculumCode}}/level3reg.cfm?entity_id={{pgaId}}`,
}

export const getCurriculumCode = (version) => {
  const versionMap = {
    '3.0': 'pgapgm30',
    '3.1': 'pgapgm31',
  }

  if (!version || !versionMap[version]) {
    console.error(`[getCurriculumCode] Unsupported curriculum version: "${version}". Expected "3.0" or "3.1". Defaulting to "3.1"`)
    return 'pgapgm31'
  }
  
  return versionMap[version]
}

export const MAP_URLS = {
  // PGA Headquarters in Frisco, TX - 1916 PGA Pkwy, Frisco, TX 75034
  PGA_HQ: `${EXTERNAL_DOMAINS.GOOGLE_MAPS}/place/1916+PGA+Pkwy,+Frisco,+TX+75034`,
}

export const getCanvasUrl = (context = 'home') => {
  const urlMap = {
    home: CANVAS_URLS.HOME,
    courses: CANVAS_URLS.COURSES,
    portfolio: CANVAS_URLS.LEVEL_1_PORTFOLIO,
    conference: CANVAS_URLS.VIRTUAL_SEMINAR_CONFERENCE,
  }
  return urlMap[context] || CANVAS_URLS.HOME
}

export const getEventsUrl = (searchType = 'home') => {
  const urlMap = {
    'pat': EVENTS_URLS.PAT_SEARCH,
    'education': EVENTS_URLS.EDUCATION_SEARCH,
    'virtual-seminar': EVENTS_URLS.VIRTUAL_SEMINAR_L1_SEARCH,
    'my-events': EVENTS_URLS.MY_EVENTS,
    'home': EVENTS_URLS.HOME,
  }
  return urlMap[searchType] || EVENTS_URLS.HOME
}

export const getLevelRegistrationUrl = (level) => {
  return level === 2 ? LEGACY_APP_URLS.LEVEL_2_REGISTRATION : LEGACY_APP_URLS.LEVEL_3_REGISTRATION
}
